import styled from 'styled-components'

export const ExclusiveOfferDivWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 2px dashed #ffc542;
	box-sizing: border-box;
	border-radius: var(--border-radius-sm);
	padding: var(--pd-sm);
	margin: var(--mg-sm);
`

export const OfferSpan = styled.span`
	font-size: var(--fs-xl);
	margin: 0px var(--mg-sm);
`
